/**
 * THE DOWNLOAD MODULE'S DOOR (owner, 2026-10-22: "need new module in sidebar and show only admin permission users").
 *
 * Download is not a role module. A role module is a row in `role_modules` that every role editor can hand out, and the SuperAdmin and
 * System Administrator hold all of them — so it would open for whoever was ticked, with no connection to the permission that actually
 * lets the server build and release a workbook of patient and money records. Here the permission IS the door:
 *
 *   - `DOWNLOAD` is not in `NAV_MODULE_CODES`, so Administration → Roles never offers it as a module;
 *   - it is added to the user's module codes HERE, only while their login token carries `data-export:read`;
 *   - whatever the token carries under that name is thrown away first, so a stray `role_modules` row cannot open it either.
 *
 * Everything that offers or opens the module — the workspace switcher, the sidebar, global search, the route — reads its codes through
 * `useEffectiveModuleCodes` (or `hasModuleAccess`), so they cannot disagree. The server checks the permission again on every request.
 */
import { PlatformPermissions } from '@nexao/contracts';

export const DOWNLOAD_MODULE = 'DOWNLOAD';

export function withDownloadAccess(moduleCodes: readonly string[], permissions: readonly string[]): string[] {
  const rest = moduleCodes.filter((code) => code !== DOWNLOAD_MODULE);
  return permissions.includes(PlatformPermissions.DATA_EXPORT_READ) ? [...rest, DOWNLOAD_MODULE] : rest;
}
